import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useUserRole } from '../hooks/useUserRole';
import './UnauthorizedPage.css';

function UnauthorizedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { role, loading, canAccessAdminPanel } = useUserRole();

  useEffect(() => {
    if (!loading && user && canAccessAdminPanel()) {
      navigate('/', { replace: true });
    }
  }, [loading, user, role, canAccessAdminPanel, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error signing out:', error);
      navigate('/login', { replace: true });
    }
  };

  const handleGoBack = () => {
    navigate('/login', { replace: true });
  };

  const getRoleMessage = () => {
    switch (role) {
      case 'COMANDA':
        return t('unauthorized.roleComanda');
      default:
        return t('unauthorized.roleDefault');
    }
  };

  if (loading) {
    return null;
  }

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="unauthorized-icon">🚫</div>
        <h1>{t('unauthorized.title')}</h1>
        <p className="unauthorized-message">{t('unauthorized.message')}</p>
        {user && <p className="role-info">{getRoleMessage()}</p>}

        {role === 'COMANDA' && (
          <div className="comanda-info">
            <p>
              {t('unauthorized.comandaRedirect')} <strong>{t('unauthorized.comandaApp')}</strong>
            </p>
            <p className="app-url">
              <a
                href={process.env.REACT_APP_COMANDA_URL || '/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('unauthorized.goToComanda')}
              </a>
            </p>
          </div>
        )}

        <div className="unauthorized-actions">
          <button type="button" onClick={handleLogout} className="btn btn-primary">
            {t('unauthorized.logout')}
          </button>
          <button type="button" onClick={handleGoBack} className="btn btn-secondary">
            {t('unauthorized.goToLogin')}
          </button>
        </div>

        <div className="contact-info">
          <p>{t('unauthorized.contactAdmin')}</p>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedPage;
